import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'),
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'Layout',
      component: () => import('@/layout/index.vue'),
      redirect: '/dashboard',
      meta: { requiresAuth: true },
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard.vue'),
          meta: { title: '仪表板', icon: 'DataBoard' }
        },
        {
          path: '/wallets',
          name: 'Wallets',
          component: () => import('@/views/Wallets.vue'),
          meta: { title: '钱包管理', icon: 'Wallet' }
        },
        {
          path: '/apps',
          name: 'Apps',
          component: () => import('@/views/AppManagement.vue'),
          meta: { title: '应用管理', icon: 'Grid' }
        },
        {
          path: '/app-logs',
          name: 'AppLogs',
          component: () => import('@/views/AppLogs.vue'),
          meta: { title: '应用日志', icon: 'Document' }
        },
        {
          path: '/admins',
          name: 'Admins',
          component: () => import('@/views/Admins.vue'),
          meta: { title: '管理员', icon: 'User' }
        },
        {
          path: '/security',
          name: 'Security',
          component: () => import('@/views/Security.vue'),
          meta: { title: '安全监控', icon: 'Lock' }
        },
        {
          path: '/profile',
          name: 'Profile',
          component: () => import('@/views/Profile.vue'),
          meta: { title: '个人资料', icon: 'UserFilled' }
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/login' && authStore.isAuthenticated) {
    next('/')
  } else {
    next()
  }
})

export default router
